import "./index.css";
import type { ReactNode } from "react";
import clsx from "clsx";

type IProps = {
  children: ReactNode;
  className?: string;
};

export const Page = ({ children, className }: IProps) => {
  const rootClass = clsx("page", className);
  return <div className={rootClass}>{children}</div>;
};
